import { useMutation } from "urql";

import { UpdateCollateralDocument } from "../../../graphql/generated.ts";

export const useUpdateCollateral = () => useMutation(UpdateCollateralDocument);
